import { render, staticRenderFns } from "./Parkingorders.vue?vue&type=template&id=2aa01700&scoped=true&"
import script from "./Parkingorders.vue?vue&type=script&lang=js&"
export * from "./Parkingorders.vue?vue&type=script&lang=js&"
import style0 from "./Parkingorders.vue?vue&type=style&index=0&id=2aa01700&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa01700",
  null
  
)

export default component.exports